module.exports = __webpack_public_path__ + "static/media/linktr_icon.c4de2875.webp";